import { render, staticRenderFns } from "./PageWechatGuideShare.vue?vue&type=template&id=f7d08df6&scoped=true"
import script from "./PageWechatGuideShare.vue?vue&type=script&lang=js"
export * from "./PageWechatGuideShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d08df6",
  null
  
)

export default component.exports